@let card = data();
<big-ui-card
    [hasLink]="!!card.link"
    [isComplex]="true">
    <div
        *transloco="let t; prefix: 'uiCard'"
        class="relative flex flex-col h-full min-w-0 overflow-hidden bg-clip-border"
        [class.md:flex-row]="imagePlacement() !== 'top'">
        <div
            [ngClass]="{
                'md:w-1/2 md:overflow-hidden': imagePlacement() !== 'top',
                'w-full': imagePlacement() === 'top',
                'md:order-last': imagePlacement() === 'right',
            }">
            <big-ui-picture
                [model]="card.image"
                class="object-cover"
                [pictureClass]="imagePlacement() === 'top' ? 'aspect-3/2' : 'aspect-3/2 md:aspect-square'" />
        </div>
        <div
            class="grow flex-1/2 p-6 flex gap-4 flex-col h-full"
            [ngClass]="{ 'order-last md:order-first!': imagePlacement() === 'right' }">
            @if (card.date) {
                <p class="mb-0! text-[12px]">
                    <time>{{ card.date | date }}</time>
                </p>
            }
            <h5 class="mb-0!">{{ card.title }}</h5>
            @if (card.text) {
                <div
                    class="grow"
                    [innerHTML]="card.text | nl2br | sanitize: securityContext"></div>
            }
            <big-ui-card-link
                [class.-mt-4]="hideLink()"
                [link]="card.link"
                [hideLink]="hideLink()" />
        </div>
    </div>
</big-ui-card>
